import { API, graphqlOperation } from 'aws-amplify';
import { GraphQLResult } from '@aws-amplify/api-graphql';
import { updateAITraining } from '../../../../graphql/mutations';

interface UpdateAITrainingInput {
  id: string;
  orgID?: string;
  service?: string;
  name?: string;
  description?: string;
  prompt?: string;
  revision?: number;
  status?: string;
  users?: string[];
  public?: boolean;
  createdBy?: string;
  lastUpdatedBy?: string;
}

interface UpdateAITrainingResponse {
  updateAITraining: {
    id: string;
    orgID: string;
    service: string;
    name: string;
    description?: string;
    prompt: string;
    revision: number;
    status?: string;
    users?: string[];
    public?: boolean;
    createdBy?: string;
    lastUpdatedBy?: string;
    createdAt: string;
    updatedAt: string;
  };
}

export async function updateAITrainingEntry(
  input: UpdateAITrainingInput
): Promise<UpdateAITrainingResponse['updateAITraining'] | null> {
  try {
    // @ts-ignore
    const { me } = global;

    const trainingInput = {
      ...input,
      lastUpdatedBy: me.id,
    };

    const result = (await API.graphql(
      graphqlOperation(updateAITraining, {
        input: trainingInput,
      })
    )) as GraphQLResult<UpdateAITrainingResponse>;

    const updatedTraining = result.data?.updateAITraining;
    if (updatedTraining) {
      console.log(`AI Training ${updatedTraining.name} updated successfully.`);
      return updatedTraining;
    } else {
      console.error(`Failed to update AI training with ID: ${input.id}`);
      return null;
    }
  } catch (error) {
    console.error('Error updating AI training:', error);
    throw error;
  }
}
